// Bot de ayuda del panel lealtad (E7, 2026-08-31): POST /help/ask en lealify-base.
// El backend resuelve el vertical del tenant y responde solo con el manual de lealtad.
// 200 -> { answer }. Errores: 400 (pregunta corta), 429 (rate limit), 502 (falló el asistente).
import { baseApi } from './baseClient';

export const askHelpBot = async (question: string): Promise<string> => {
  const data = await baseApi.post<{ answer?: string }>('/help/ask', { question });
  return data?.answer || '';
};
